/**
 * Azure Services Configuration
 * Configuration for Azure OpenAI and other Azure services
 *
 * Uses runtime configuration (injected at container startup) with fallback to build-time values
 */

import {
  getAzureOpenAIEndpoint,
  getAzureOpenAIDeployment,
  getAzureOpenAIAPIVersion,
} from './runtimeConfig';

export const azureConfig = {
  openai: {
    endpoint: getAzureOpenAIEndpoint() || '',
    deployment: getAzureOpenAIDeployment() || '',
    apiVersion: getAzureOpenAIAPIVersion(),
  },
  graph: {
    endpoint: import.meta.env.VITE_GRAPH_API_ENDPOINT ||
              'https://graph.microsoft.com/v1.0',
  },
};

export const appConfig = {
  name: import.meta.env.VITE_APP_NAME || 'Stellar Assistant',
  maxFileSize: parseInt(
    import.meta.env.VITE_MAX_FILE_SIZE || '10485760',
    10
  ),
  maxFiles: parseInt(import.meta.env.VITE_MAX_FILES || '5', 10),
};
